import requests from '../shared/agent'

const endpoint = '/licenses'

const LicenseService = {
  listAll: async () => {
    return await requests.get(`${endpoint}/request/`)
  }
}

export default LicenseService
